// Tipologie cliente ufficiali del CRM e documentazione richiesta per la valutazione di fattibilità
export const TIPOLOGIE_CLIENTE = [
  { value: 'privato_dipendente', label: 'Privati / Dipendenti', short: 'Priv.' },
  { value: 'pensionato', label: 'Pensionati', short: 'Pens.' },
  { value: 'libero_professionista', label: 'Liberi Professionisti', short: 'L.Prof' },
  { value: 'ditta_individuale', label: 'Ditte Individuali', short: 'Ditta' },
  { value: 'societa_persone', label: 'Società di Persone (Snc, Sas)', short: 'Soc.P.' },
  { value: 'societa_capitale', label: 'Società di Capitali (Srl, Spa)', short: 'Soc.' },
  { value: 'ente', label: 'Enti (Onlus, Associazioni, Sindacati)', short: 'Ente' },
  { value: 'societa_estera', label: 'Società Estere', short: 'Estera' },
];

// Valore storico ancora presente su alcune anagrafiche
const LEGACY = { dipendente_pensionato: { label: 'Dipendente/Pensionato', short: 'Dip.' } };

export const tipologiaLabel = (value, fallback = '') =>
  TIPOLOGIE_CLIENTE.find((t) => t.value === value)?.label || LEGACY[value]?.label || fallback;

export const tipologiaShort = (value, fallback = '') =>
  TIPOLOGIE_CLIENTE.find((t) => t.value === value)?.short || LEGACY[value]?.short || fallback;

// Tipologie con persona fisica (CF obbligatorio, P.IVA non richiesta)
export const isPersonaFisica = (value) => ['privato_dipendente', 'pensionato', 'dipendente_pensionato'].includes(value);
export const isPersonaGiuridica = (value) => ['societa_persone', 'societa_capitale', 'ente', 'societa_estera'].includes(value);

export const DOCUMENTI_BASE = [
  "Copia Documento d'Identità",
  'Patente di guida',
  'Tessera Sanitaria (fronte/retro)',
  'Modulo PRIVACY firmato',
  'Codice IBAN',
];

export const DOCUMENTI_PER_TIPOLOGIA = {
  privato_dipendente: { docs: ['Ultime 2 buste paga', 'Certificazione Unica (CU)'], nota: 'Neoassunti: contratto di lavoro' },
  pensionato: { docs: ['Ultimo cedolino pensione o estratto conto con accredito', 'Certificazione Unica (CU)'], nota: 'Neopensionati: lettera INPS' },
  libero_professionista: { docs: ['Ultimo Modello UNICO PF con ricevuta di presentazione', 'Certificato attribuzione Partita IVA'] },
  ditta_individuale: { docs: ['Ultimo Modello UNICO PF con ricevuta di presentazione', 'Visura Camerale (max 3 mesi)'], nota: 'Agricole: modello IRAP' },
  societa_persone: { docs: ['Ultimo Modello SP con ricevuta di presentazione', 'Visura Camerale (max 3 mesi)'] },
  societa_capitale: { docs: ['Ultimo Bilancio depositato con ricevuta di deposito', 'Visura Camerale (max 3 mesi)'] },
  ente: { docs: ["Ultimo Bilancio o contabilità dell'ultimo anno fiscale", 'Statuto ente', 'Poteri firma legale rappresentante'], nota: 'Delibera di Spesa' },
  societa_estera: { docs: ['Bilancio Individuale (preferibilmente in inglese)', 'Modello Unico sede secondaria italiana', 'Visura Camerale (se sede IT) o documento equivalente estero'] },
  dipendente_pensionato: { docs: ['Ultime 2 buste paga oppure ultimo cedolino pensione', 'Certificazione Unica (CU)'], nota: 'Neoassunti: contratto di lavoro · Neopensionati: lettera INPS' },
};
